// In development, use proxy (empty string)
// In production, use relative paths
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : '';

const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  
  ENDPOINTS: {
    PRODUCTS: `${API_BASE_URL}/products`,
    FEATURED_PRODUCTS: `${API_BASE_URL}/products/featured`,
    PRODUCT_BY_ID: (id) => `${API_BASE_URL}/products/${id}`,
    
    AUTH_LOGIN: `${API_BASE_URL}/auth/login`,
    AUTH_REGISTER: `${API_BASE_URL}/auth/register`,
    AUTH_ME: `${API_BASE_URL}/auth/me`,
    
    CART: `${API_BASE_URL}/cart`,
    CART_ADD: `${API_BASE_URL}/cart/items`,
    CART_ITEM: (id) => `${API_BASE_URL}/cart/items/${id}`,
    
    ORDERS: `${API_BASE_URL}/orders`,
    MY_ORDERS: `${API_BASE_URL}/orders/my-orders`,
    SUBSCRIBE: `${API_BASE_URL}/subscribe`,
    SUBSCRIBE_NOTIFY: `${API_BASE_URL}/subscribe/notify`,
    
    HEALTH: `${API_BASE_URL}/health`
  }
};

export default API_CONFIG;